import {
    CREATE_CUTTING_INWARD_DETAILS_REQUEST_DK,
    CREATE_CUTTING_INWARD_DETAILS_SUCCESS_DK,
    CREATE_CUTTING_INWARD_DETAILS_FAILURE_DK,
    DELETE_CUTTING_INWARD_DETAILS_REQUEST_DK,
    DELETE_CUTTING_INWARD_DETAILS_SUCCESS_DK,
    DELETE_CUTTING_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_CUTTING_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_CUTTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_CUTTING_INWARD_DETAILS_FAILURE_DK,
    FETCH_CUTTING_INWARD_DETAILS_REQUEST_DK,
    FETCH_CUTTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_CUTTING_INWARD_DETAILS_FAILURE_DK,
    UPDATE_CUTTING_INWARD_DETAILS_REQUEST_DK,
    UPDATE_CUTTING_INWARD_DETAILS_SUCCESS_DK,
    UPDATE_CUTTING_INWARD_DETAILS_FAILURE_DK,
    RESET_CUTTING_INWARD_DETAILS_INFO_DK,
    CREATE_CUTTING_INWARD_DETAILS_FORM_DK,
    UPDATE_CUTTING_INWARD_DETAILS_FORM_DK,
    FETCH_CUTTING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_FAILURE_DK
} from './cuttingInwardDetails.actionsType';

export const CUTTING_INWARD_DK_DETAILS = 'cuttingInwardDKDetails';

let initialState = {
    loading: false,
    cuttingInwardDetails: [],
    cuttingInwardDetailsWithoutId: [],
    previousGetList: [],
    cuttingInwardDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        // fldReceivingRolls: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0
    },
    selectedState: {},
    errorMessage: ''
};

export let cuttingInwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CUTTING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_REQUEST_DK:
        case CREATE_CUTTING_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_CUTTING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_CUTTING_INWARD_DETAILS_REQUEST_DK:
        case DELETE_CUTTING_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_CUTTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardDetails: updatePayload
            };
        case FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.IPI
            };
        case FETCH_CUTTING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardDetailsWithoutId: updatePayload
            };
        case CREATE_CUTTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case UPDATE_CUTTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case FETCH_SINGLE_CUTTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardDetailsForm: updatePayload
            };
        case DELETE_CUTTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case RESET_CUTTING_INWARD_DETAILS_INFO_DK:
            return {
                ...state,
                cuttingInwardDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    // fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0
                }
            };
        case CREATE_CUTTING_INWARD_DETAILS_FORM_DK:
        case UPDATE_CUTTING_INWARD_DETAILS_FORM_DK:
            return {
                ...state,
                loading: false,
                cuttingInwardDetailsForm: {
                    ...state.cuttingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_CUTTING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_CUTTING_INWARD_DETAILS_FAILURE_DK:
        case CREATE_CUTTING_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_CUTTING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_CUTTING_INWARD_DETAILS_FAILURE_DK:
        case DELETE_CUTTING_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
